import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faComments,
  faDatabase,
  faCodeBranch,
  faChartLine,
  faLightbulb,
  faShieldHalved,
} from '@fortawesome/free-solid-svg-icons';

export default function Features() {
  const data = [
    {
      icon: faComments,
      title: 'Natural Language Querying',
      desc: 'Ask complex data questions in plain English — no SQL knowledge needed.',
    },
    {
      icon: faDatabase,
      title: 'Multi-Source Integration',
      desc: 'Combine databases and CSV files for unified cross-source analysis.',
    },
    {
      icon: faCodeBranch,
      title: 'CSV Comparison Intelligence',
      desc: 'Compare files side-by-side, detect trends, and find differences instantly.',
    },
    {
      icon: faChartLine,
      title: 'Automated Visualization',
      desc: 'Generate charts, graphs, and trends automatically from your data.',
    },
    {
      icon: faLightbulb,
      title: 'Smart Insights',
      desc: 'AI highlights patterns, anomalies, and key observations you might miss.',
    },
    {
      icon: faShieldHalved,
      title: 'Secure & Private',
      desc: 'Read-only queries, input sanitization, and no data stored on servers.',
    },
  ];

  return (
    <section id="features" style={s.section}>
      
      {/* Header */}
      <div style={s.header}>
        <h2 style={s.title}>
          Powerful <span style={s.gradient}>Features</span>
        </h2>
        <p style={s.sub}>
          Everything you need to transform raw data into actionable intelligence.
        </p>
      </div>

      {/* Grid */}
      <div style={s.grid}>
        {data.map((f, i) => (
          <div key={i} style={s.card}>

            <div style={s.iconWrap}>
              <FontAwesomeIcon icon={f.icon} />
            </div>

            <h3 style={s.cardTitle}>{f.title}</h3>
            <p style={s.desc}>{f.desc}</p>

          </div>
        ))}
      </div>

    </section>
  );
}
const s = {
  section: {
    padding: '90px 80px',
    textAlign: 'center',
    background:'linear-gradient(135deg,#eef2ff,#f8fafc)'
  },

  header: {
    marginBottom: 60,
  },

  title: {
    fontSize: 36,
    fontWeight: 800,
    marginBottom: 10,
  },

  gradient: {
    background: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },

  sub: {
    fontSize: 15,
    color: 'var(--text-muted)',
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 24,
  },

  card: {
    textAlign: 'left',
    padding: '28px 26px',
    borderRadius: 18,
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.05)',
    boxShadow: '0 12px 40px rgba(0,0,0,0.05)',
    transition: 'all 0.25s ease',
  },

  iconWrap: {
    width: 52,
    height: 52,
    borderRadius: 14,
    background: 'rgba(99,102,241,0.12)',
    color: '#6366f1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    marginBottom: 18,
  },

  cardTitle: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 10,
  },

  desc: {
    fontSize: 14,
    color: 'var(--text-muted)',
    lineHeight: 1.6,
  },
};